import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Icon } from 'edcom-ui';
import styles from './FilterChips.module.less';

export default function SelectedContentChips({ selected, unSelect }) {
  let plural = selected.length > 1 ? 's' : '';
  let filterDisplay = selected.length + ' selection' + plural;

  return (
    <div
      className={clsx(styles.chip, styles.selected)}
      title={'Un-selected'}
      onClick={() => {
        unSelect([]);
      }}
      role="link"
    >
      {filterDisplay}
      <Icon name="cancel-circled" />
    </div>
  );
}

SelectedContentChips.propTypes = {
  selected: PropTypes.array,
  unSelect: PropTypes.func,
};
